import React, { useEffect, useMemo, useState } from "react";
import {
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Label,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";

import DeleteModal from "../../../../Components/Common/DeleteModal";

import { toast } from "react-toastify";

import {
  calendarNonWorkingDayData,
  calendarNonWorkingDayDelete,
  calendarNonWorkingDayDeleteSuccess,
  calendarNonWorkingDayList,
  staffHolidayCalendarData,
  staffHolidayCalendarDelete,
  staffHolidayCalendarDeleteSuccess,
  staffHolidayCalendarGeneratePeriods,
  staffHolidayCalendarGeneratePeriodsSuccess,
  staffHolidayCalendarList,
  staffHolidayCalendarPeriodData,
  staffHolidayCalendarPeriodDelete,
  staffHolidayCalendarPeriodDeleteSuccess,
  staffHolidayCalendarPeriodList,
  staffLeaveRestrictionPeriodData,
  staffLeaveRestrictionPeriodDelete,
  staffLeaveRestrictionPeriodDeleteSuccess,
  staffLeaveRestrictionPeriodList,
} from "../../../../store/staffLeave/action";
import HandleDateTime from "../../../../Components/Common/HandleDateTime";
import LoadingSpinner from "../../../../Components/Common/Spinner";
import TableContainer from "../../../../Components/Common/TableContainer";
import NoDataContent from "../../../../Components/Common/NoDataContent";
import LocalDataSearch from "../../../../Components/SearchAndFilter";
import CreateEditStaffHolidayCalendarConfig from "../../../../Components/popUpComponents/CreateEditStaffHolidayCalendarConfig";
import CreateEditStaffHolidayPeriodConfig from "../../../../Components/popUpComponents/CreateEditStaffHolidayPeriodConfig";
import CreateEditStaffHolidayNonWorkingDayConfig from "../../../../Components/popUpComponents/CreateEditStaffHolidayNonWorkingDayConfig";
import CreateEditStaffLeaveRestrictionPeriodConfig from "../../../../Components/popUpComponents/CreateEditStaffLeaveRestrictionPeriodConfig";
import SettingsPanel from "../../components/SettingsPanel";
import CreateEditStaffLeaveTypeConfig from "../../../../Components/popUpComponents/CreateEditStaffLeaveTypeConfig";
import {
  deleteStaffLeaveType,
  deleteStaffLeaveTypeSuccess,
  getStaffLeaveTypeList,
} from "../../../../store/actions";
import { useParams } from "react-router-dom";

// Task 24479. The Settings > Staff panel signposts leave types with a button to
// /settings/1/29/leave-types, but this panel only ever kept the active tab in
// local state, so that link landed on Staff Holiday Calendar and the signpost
// pointed at the wrong thing. The route already carries an :activeTab segment
// (Task 20780) - it just was not being read here.
//
// Slugs are accepted as well as the raw numeric ids so the URL says what it
// opens; an unknown value falls back to the first tab rather than rendering a
// panel with nothing selected.
const TAB_SLUGS = {
  "holiday-calendars": "1",
  "holiday-calendar-periods": "2",
  "non-working-days": "3",
  "staff-leave-restriction-periods": "4",
  "leave-types": "5",
};

const resolveTabFromUrl = (value) => {
  if (!value) return "1";
  const key = String(value).trim().toLowerCase();
  if (TAB_SLUGS[key]) return TAB_SLUGS[key];
  if (Object.values(TAB_SLUGS).includes(key)) return key;
  return "1";
};

export default function StaffLeaveSettingsPage() {
  const dispatch = useDispatch();

  const params = useParams();

  const [dataAPI, setDataAPI] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(() =>
    resolveTabFromUrl(params?.activeTab)
  );

  // Follows the URL when it changes, so navigating between two settings links
  // switches tab instead of leaving whichever one was opened first.
  useEffect(() => {
    setActiveTab(resolveTabFromUrl(params?.activeTab));
  }, [params?.activeTab]);
  const [deleteStatus, setDeleteStatus] = useState("");

  useEffect(() => {
    dispatch(getStaffLeaveTypeList());
    dispatch(staffHolidayCalendarList());
    dispatch(staffHolidayCalendarPeriodList());
    dispatch(calendarNonWorkingDayList());
    dispatch(staffLeaveRestrictionPeriodList());
  }, []);

  const {
    staffHolidayCalendarListAPI,
    staffHolidayCalendarListLoading,
    staffHolidayCalendarPeriodListAPI,
    staffHolidayCalendarPeriodListLoading,
    calendarNonWorkingDayListAPI,
    calendarNonWorkingDayListLoading,
    staffLeaveRestrictionPeriodListAPI,
    staffLeaveRestrictionPeriodListLoading,
    staffLeaveTypeListAPI,
    staffLeaveTypeListLoading,
  } = useSelector((state) => ({
    staffHolidayCalendarListAPI:
      state.StaffLeave.staffHolidayCalendarList?.staffholidaycalendar_list,
    staffHolidayCalendarListLoading:
      state.StaffLeave.staffHolidayCalendarListLoading,
    staffHolidayCalendarPeriodListAPI:
      state.StaffLeave.staffHolidayCalendarPeriodList
        ?.staffholidaycalendarperiod_list,
    staffHolidayCalendarPeriodListLoading:
      state.StaffLeave.staffHolidayCalendarPeriodListLoading,
    calendarNonWorkingDayListAPI:
      state.StaffLeave.calendarNonWorkingDayList?.calendarnonworkingday_list,
    calendarNonWorkingDayListLoading:
      state.StaffLeave.calendarNonWorkingDayListLoading,
    staffLeaveTypeListAPI: state.Staff?.staffLeaveTypeList?.staffleavetype_list,
    staffLeaveTypeListLoading: state.Staff?.loadingStaffLeaveTypeList,
    staffLeaveRestrictionPeriodListAPI:
      state.StaffLeave.staffLeaveRestrictionPeriodList
        ?.staffleaverestrictionperiod_list,
    staffLeaveRestrictionPeriodListLoading:
      state.StaffLeave.staffLeaveRestrictionPeriodListLoading,
  }));

  console.log("calendarNonWorkingDayListAPI", calendarNonWorkingDayListAPI);
  useEffect(() => {
    if (
      staffHolidayCalendarListLoading ||
      staffHolidayCalendarPeriodListLoading ||
      calendarNonWorkingDayListLoading ||
      staffLeaveRestrictionPeriodListLoading
    ) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [
    staffHolidayCalendarListLoading,
    staffHolidayCalendarPeriodListLoading,
    calendarNonWorkingDayListLoading,
    staffLeaveRestrictionPeriodListLoading,
  ]);

  const column_StaffHolidayCalendarList = useMemo(
    () => [
      {
        // job id  with beginning #Job_Id
        Header: "Id",
        accessor: "Id",
      },
      {
        Header: "Name",
        accessor: "Name",
      },
      {
        Header: "Description",
        accessor: (row) => {
          return (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                maxWidth: "400px",
                wordWrap: "break-word",
              }}
            >
              {row.Description}
            </div>
          );
        },
      },

      {
        Header: "Auto Open Upon Renewal",
        accessor: (row) => {
          return (
            <div>{row?.FlagAutoOpenUponRenewal === "1" ? "Yes" : "No"}</div>
          );
        },
        filterable: true,
      },
      {
        Header: "Days To Open Next Renewal",
        accessor: (row) => {
          return <div>{row?.DaysToOpenNextRenewal}</div>;
        },
        filterable: true,
      },
      {
        Header: "Start Date Day",
        accessor: (row) => {
          return <div>{row?.StartDateDay}</div>;
        },
        filterable: true,
      },
      {
        Header: "Start Date Month",
        accessor: (row) => {
          return <div>{row?.StartDateMonth}</div>;
        },
        filterable: true,
      },
      {
        Header: "End Date Day",
        accessor: (row) => {
          return <div>{row?.EndDateDay}</div>;
        },
        filterable: true,
      },
      {
        Header: "End Date Month",
        accessor: (row) => {
          return <div>{row?.EndDateMonth}</div>;
        },
        filterable: true,
      },
      {
        Header: "Working Day Hours",
        accessor: (row) => {
          return <div>{row?.QtyOfHoursInSingleDay}</div>;
        },
        filterable: true,
      },
      {
        Header: "Created Date",
        accessor: (row) => {
          //CreatedDateTime sort date so its day Month name Year and time

          return <div>{HandleDateTime(row.CreatedDateTime)}</div>;

          // return row.CreatedDateTime
        },
        filterable: true,
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle
                href="#"
                className="btn-soft-secondary btn-sm dropdown"
                tag="button"
              >
                <i className="ri-more-fill align-middle"></i>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                  onClick={() => {
                    setIsEdit(true);
                    dispatch(
                      staffHolidayCalendarData({
                        id: cellProps.row.original.Id,
                      })
                    );
                    toggleModalAddNewStaffHolidayCalendar();
                  }}
                >
                  <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>{" "}
                  Edit
                </DropdownItem>

                <DropdownItem
                  onClick={() => {
                    setDeleteStatus(cellProps.row.original.Id);
                    setDeleteModal(true);
                  }}
                >
                  <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>{" "}
                  Delete
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        },
      },
    ],
    []
  );
  const column_StaffHolidayCalendarPeriodList = useMemo(
    () => [
      {
        // job id  with beginning #Job_Id
        Header: "Id",
        accessor: "Id",
      },
      {
        Header: "Staff Holiday Calendar",
        accessor: "StaffHolidayCalendar_Id",
        Cell: (cellProps) => {
          return (
            <div>
              {cellProps.row.original.StaffHolidayCalendar_Name}{" "}
              <span>(#{cellProps.row.original.StaffHolidayCalendar_Id})</span>
            </div>
          );
        },
      },
      {
        Header: "Start Date",
        accessor: (row) => {
          return <div>{HandleDateTime(row?.StartDate)}</div>;
        },
        filterable: true,
      },
      {
        Header: "End Date",
        accessor: (row) => {
          return <div>{HandleDateTime(row?.EndDate)}</div>;
        },
        filterable: true,
      },
      {
        Header: "Default Staff Decision Expiry Duration Minutes",
        accessor: (row) => {
          return <div>{row?.DefaultStaffDecisionExpiryDurationMinutes}</div>;
        },
        filterable: true,
      },
      {
        Header: "Notes",
        accessor: (row) => {
          return <div>{row?.Notes}</div>;
        },
        filterable: true,
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle
                href="#"
                className="btn-soft-secondary btn-sm dropdown"
                tag="button"
              >
                <i className="ri-more-fill align-middle"></i>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                  onClick={() => {
                    setIsEdit(true);
                    dispatch(
                      staffHolidayCalendarPeriodData({
                        id: cellProps.row.original.Id,
                      })
                    );
                    toggleModalAddNewStaffHolidayPeriod();
                  }}
                >
                  <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>{" "}
                  Edit
                </DropdownItem>

                <DropdownItem
                  onClick={() => {
                    setDeleteStatus(cellProps.row.original.Id);
                    setDeleteModal(true);
                  }}
                >
                  <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>{" "}
                  Delete
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        },
      },
    ],
    []
  );
  const column_StaffLeaveRestrictionPeriodList = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "Id",
      },
      {
        Header: "Start Date",
        accessor: (row) => {
          return <div>{HandleDateTime(row?.StartDateTime)}</div>;
        },
        filterable: true,
      },
      {
        Header: "End Date",
        accessor: (row) => {
          return <div>{HandleDateTime(row?.EndDateTime)}</div>;
        },
        filterable: true,
      },
      {
        Header: "Full Day",
        accessor: (row) => {
          return <div>{row?.FlagFullDay === "1" ? "Yes" : "No"}</div>;
        },
        filterable: true,
      },
      {
        // Task 24488 - this column used to read the old
        // FlagBlockUserRequestingHoliday boolean, which the dialog never set,
        // so it said "No" on every row. It now shows the restriction's strength.
        Header: "Strictness",
        accessor: (row) => {
          const isSoft =
            String(row?.RestrictionType || "").toUpperCase() === "SOFT";
          return (
            <span
              className={`badge ${
                isSoft ? "badge-soft-warning" : "badge-soft-danger"
              }`}
              title={
                isSoft
                  ? "Staff are warned but can still submit; the approver sees the warning too"
                  : "Staff cannot request leave over these dates"
              }
            >
              {isSoft ? "Soft stop" : "Hard stop"}
            </span>
          );
        },
        filterable: true,
      },
      {
        Header: "Notes",
        accessor: (row) => {
          return <div>{row?.Notes}</div>;
        },
        filterable: true,
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle
                href="#"
                className="btn-soft-secondary btn-sm dropdown"
                tag="button"
              >
                <i className="ri-more-fill align-middle"></i>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                  onClick={() => {
                    setIsEdit(true);
                    dispatch(
                      staffLeaveRestrictionPeriodData({
                        id: cellProps.row.original.Id,
                      })
                    );
                    toggleModalAddNewStaffLeaveRestrictionPeriod();
                  }}
                >
                  <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>{" "}
                  Edit
                </DropdownItem>

                <DropdownItem
                  onClick={() => {
                    setDeleteStatus(cellProps.row.original.Id);
                    setDeleteModal(true);
                  }}
                >
                  <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>{" "}
                  Delete
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        },
      },
    ],
    []
  );

  const column_StaffHolidayCalendarNonWorkingDayList = useMemo(
    () => [
      {
        // job id  with beginning #Job_Id
        Header: "Id",
        accessor: "Id",
      },
      {
        Header: "Name",
        accessor: "Name",
      },

      {
        Header: "Start Date",
        accessor: (row) => {
          return <div>{HandleDateTime(row?.StartDateTime)}</div>;
        },
        filterable: true,
      },
      {
        Header: "End Date",
        accessor: (row) => {
          return <div>{HandleDateTime(row?.EndDateTime)}</div>;
        },
        filterable: true,
      },

      {
        Header: "All Day",
        accessor: (row) => {
          return <div>{row?.FlagAllDay === "1" ? "Yes" : "No"}</div>;
        },
        filterable: true,
      },
      {
        Header: "Public Holiday",
        accessor: (row) => {
          return <div>{row?.FlagPublicHoliday === "1" ? "Yes" : "No"}</div>;
        },
        filterable: true,
      },
      {
        Header: "Notes",
        accessor: (row) => {
          return <div>{row?.Notes}</div>;
        },
        filterable: true,
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle
                href="#"
                className="btn-soft-secondary btn-sm dropdown"
                tag="button"
              >
                <i className="ri-more-fill align-middle"></i>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                  onClick={() => {
                    setIsEdit(true);
                    dispatch(
                      calendarNonWorkingDayData({
                        id: cellProps.row.original.Id,
                      })
                    );
                    toggleModalAddNewStaffHolidayNonWorkingDay();
                  }}
                >
                  <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>{" "}
                  Edit
                </DropdownItem>

                <DropdownItem
                  onClick={() => {
                    setDeleteStatus(cellProps.row.original.Id);
                    setDeleteModal(true);
                  }}
                >
                  <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>{" "}
                  Delete
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        },
      },
    ],
    []
  );

  // Task 24490 - "change this to the standard tick and cross icons red/green".
  // ri-checkbox-circle-line / ri-close-circle-line with text-success /
  // text-danger is the pairing already used elsewhere in the app, so this
  // follows it rather than inventing a third convention.
  //
  // The title is not decoration: an icon on its own says nothing to a screen
  // reader, and red-vs-green is exactly the distinction some people cannot
  // make. The column header carries the question, the tooltip carries the
  // answer in words.
  const YesNoIcon = ({ on, yesText, noText }) => (
    <i
      className={`fs-5 ${
        on
          ? "ri-checkbox-circle-line text-success"
          : "ri-close-circle-line text-danger"
      }`}
      title={on ? yesText : noText}
      aria-label={on ? yesText : noText}
    ></i>
  );

  // Task 24479 - same column shape and same "..." row menu as the four tabs
  // beside it, so the tab does not read as a different product.
  const column_StaffLeaveTypeList = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "Id",
      },
      {
        Header: "Leave Type",
        accessor: (row) => (
          <span
            className="badge"
            style={{
              background: row?.CssColourBackground || "#EEF2FF",
              color: row?.CssColourText || "#4F46E5",
            }}
          >
            {row?.Name}
          </span>
        ),
        filterable: true,
      },
      {
        Header: "Description",
        accessor: (row) => <div>{row?.Description || "-"}</div>,
        filterable: true,
      },
      {
        Header: "Kind",
        accessor: (row) => (
          <div>
            {row?.StaffLeaveCategory_Name || (
              <span className="text-muted">Not set</span>
            )}
          </div>
        ),
        filterable: true,
      },
      {
        Header: "Comes Off Allowance",
        accessor: (row) => (
          <YesNoIcon
            on={String(row?.ContributeToHolidayAllowance ?? "1") === "1"}
            yesText="Comes off the holiday allowance"
            noText="Does not come off the holiday allowance"
          />
        ),
        filterable: true,
      },
      {
        Header: "On Staff Calendar",
        accessor: (row) => (
          <YesNoIcon
            on={String(row?.FlagShowStaffCalendar ?? "1") === "1"}
            yesText="Shown on the staff calendar"
            noText="Hidden from the staff calendar"
          />
        ),
        filterable: true,
      },
      {
        Header: "Order",
        accessor: (row) => <div>{row?.Order ?? "-"}</div>,
        filterable: true,
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle
                href="#"
                className="btn-soft-secondary btn-sm dropdown"
                tag="button"
              >
                <i className="ri-more-fill align-middle"></i>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                  onClick={() => {
                    setIsEdit(true);
                    setLeaveTypeUpdateData(cellProps.row.original);
                    toggleModalAddNewStaffLeaveType();
                  }}
                >
                  <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>{" "}
                  Edit
                </DropdownItem>

                <DropdownItem
                  onClick={() => {
                    setDeleteStatus(cellProps.row.original.Id);
                    setDeleteModal(true);
                  }}
                >
                  <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>{" "}
                  Delete
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        },
      },
    ],
    []
  );

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = staffHolidayCalendarListAPI;
    }
    if (activeTab === "2") {
      data = staffHolidayCalendarPeriodListAPI;
    }
    if (activeTab === "3") {
      data = calendarNonWorkingDayListAPI;
    }
    if (activeTab === "4") {
      data = staffLeaveRestrictionPeriodListAPI;
    }
    if (activeTab === "5") {
      data = staffLeaveTypeListAPI;
    }
    setDataAPI(data);
  }, [
    staffLeaveTypeListAPI,
    staffHolidayCalendarListAPI,
    staffHolidayCalendarPeriodListAPI,
    calendarNonWorkingDayListAPI,
    staffLeaveRestrictionPeriodListAPI,
    activeTab,
  ]);

  console.log("dataAPI", dataAPI);

  const Tabs = [
    {
      id: "1",
      name: "Staff Holiday Calendar",
    },
    {
      id: "2",
      name: "Staff Holiday Calendar Period",
    },
    {
      id: "3",
      name: "Calendar Non Working Days",
    },
    {
      id: "4",
      name: "Staff Leave Restriction Periods",
    },
    // Task 24479 - this is where people go looking for leave types. It used to
    // live only under Settings > Staff, a different panel entirely.
    {
      id: "5",
      name: "Leave Types",
    },
  ];
  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      dispatch(staffHolidayCalendarDelete([deleteStatus]));
    }
    if (activeTab === "2") {
      dispatch(staffHolidayCalendarPeriodDelete([deleteStatus]));
    }
    if (activeTab === "3") {
      dispatch(calendarNonWorkingDayDelete([deleteStatus]));
    }
    if (activeTab === "4") {
      dispatch(staffLeaveRestrictionPeriodDelete([deleteStatus]));
    }
    if (activeTab === "5") {
      dispatch(deleteStaffLeaveType([deleteStatus]));
    }
  };

  const {
    staffHolidayCalendarDeleteSUCCESS,
    staffHolidayCalendarPeriodDeleteSUCCESS,
    calendarNonWorkingDayDeleteSUCCESS,
    staffLeaveRestrictionPeriodDeleteSUCCESS,
    staffLeaveTypeDeleteSUCCESS,
  } = useSelector((state) => ({
    staffHolidayCalendarDeleteSUCCESS:
      state.StaffLeave.staffHolidayCalendarDelete,
    staffHolidayCalendarPeriodDeleteSUCCESS:
      state.StaffLeave.staffHolidayCalendarPeriodDelete,
    calendarNonWorkingDayDeleteSUCCESS:
      state.StaffLeave.calendarNonWorkingDayDelete,
    staffLeaveRestrictionPeriodDeleteSUCCESS:
      state.StaffLeave.staffLeaveRestrictionPeriodDelete,
    staffLeaveTypeDeleteSUCCESS: state.Staff?.deleteStaffLeaveTypeSuccess,
  }));

  useEffect(() => {
    if (isEmpty(staffLeaveTypeDeleteSUCCESS)) return;
    if (staffLeaveTypeDeleteSUCCESS.status === 200) {
      toast.success(staffLeaveTypeDeleteSUCCESS.message);
      setDeleteModal(false);
      dispatch(getStaffLeaveTypeList());
    } else {
      toast.error(staffLeaveTypeDeleteSUCCESS.message);
    }
    dispatch(deleteStaffLeaveTypeSuccess([]));
  }, [staffLeaveTypeDeleteSUCCESS]);
  //staffHolidayCalendarDeleteSUCCESS
  useEffect(() => {
    if (isEmpty(staffHolidayCalendarDeleteSUCCESS)) return;
    if (staffHolidayCalendarDeleteSUCCESS.status === 200) {
      toast.success(staffHolidayCalendarDeleteSUCCESS.message);
      setDeleteModal(false);
      dispatch(staffHolidayCalendarList());
    } else {
      toast.error(staffHolidayCalendarDeleteSUCCESS.message);
    }
    dispatch(staffHolidayCalendarDeleteSuccess([]));
  }, [staffHolidayCalendarDeleteSUCCESS]);
  //staffHolidayCalendarPeriodDeleteSUCCESS
  useEffect(() => {
    if (isEmpty(staffHolidayCalendarPeriodDeleteSUCCESS)) return;
    if (staffHolidayCalendarPeriodDeleteSUCCESS.status === 200) {
      toast.success(staffHolidayCalendarPeriodDeleteSUCCESS.message);
      setDeleteModal(false);
      dispatch(staffHolidayCalendarPeriodList());
    } else {
      toast.error(staffHolidayCalendarPeriodDeleteSUCCESS.message);
    }
    dispatch(staffHolidayCalendarPeriodDeleteSuccess([]));
  }, [staffHolidayCalendarPeriodDeleteSUCCESS]);
  //calendarNonWorkingDayDeleteSUCCESS
  useEffect(() => {
    if (isEmpty(calendarNonWorkingDayDeleteSUCCESS)) return;
    if (calendarNonWorkingDayDeleteSUCCESS.status === 200) {
      toast.success(calendarNonWorkingDayDeleteSUCCESS.message);
      setDeleteModal(false);
      dispatch(calendarNonWorkingDayList());
    } else {
      toast.error(calendarNonWorkingDayDeleteSUCCESS.message);
    }
    dispatch(calendarNonWorkingDayDeleteSuccess([]));
  }, [calendarNonWorkingDayDeleteSUCCESS]);
  //staffLeaveRestrictionPeriodDeleteSUCCESS
  useEffect(() => {
    if (isEmpty(staffLeaveRestrictionPeriodDeleteSUCCESS)) return;
    if (staffLeaveRestrictionPeriodDeleteSUCCESS.status === 200) {
      toast.success(staffLeaveRestrictionPeriodDeleteSUCCESS.message);
      setDeleteModal(false);
      dispatch(staffLeaveRestrictionPeriodList());
    } else {
      toast.error(staffLeaveRestrictionPeriodDeleteSUCCESS.message);
    }
    dispatch(staffLeaveRestrictionPeriodDeleteSuccess([]));
  }, [staffLeaveRestrictionPeriodDeleteSUCCESS]);

  //staffHolidayCalendarGeneratePeriods
  const {
    staffHolidayCalendarGeneratePeriodsSUCCESS,
    staffHolidayCalendarGeneratePeriodsLoading,
  } = useSelector((state) => ({
    staffHolidayCalendarGeneratePeriodsSUCCESS:
      state.StaffLeave.staffHolidayCalendarGeneratePeriods,
    staffHolidayCalendarGeneratePeriodsLoading:
      state.StaffLeave.staffHolidayCalendarGeneratePeriodsLoading,
  }));
  useEffect(() => {
    if (isEmpty(staffHolidayCalendarGeneratePeriodsSUCCESS)) return;
    if (staffHolidayCalendarGeneratePeriodsSUCCESS.status === 200) {
      toast.success(staffHolidayCalendarGeneratePeriodsSUCCESS.message);
      dispatch(staffHolidayCalendarPeriodList());
    } else {
      toast.error(staffHolidayCalendarGeneratePeriodsSUCCESS.message);
    }
    dispatch(staffHolidayCalendarGeneratePeriodsSuccess([]));
  }, [staffHolidayCalendarGeneratePeriodsSUCCESS]);

  const [searchResult, setSearchResult] = useState([]);
  console.log("searchResult", searchResult);
  const [searchQuery, setSearchQuery] = useState("");
  const [allowedSearchFilters, setAllowedSearchFilters] = useState([
    "Id",
    "Name",
    "Description",
  ]);
  const allowedFiltersInit = [
    {
      useThisFilter: true,
      filterTitle: "Purchase Date Range",
      filterType: "DateRange",
      filterProperty: "PurchaseDateTime",
      filterValue: {
        startDate: "",
        endDate: "",
      },
    },
    {
      useThisFilter: true,
      filterTitle: "Due Date Range",
      filterType: "DateRange",
      filterProperty: "DueDateTime",
      filterValue: {
        startDate: "",
        endDate: "",
      },
    },
    {
      useThisFilter: true,
      filterTitle: "Created Date Range",
      filterType: "DateRange",
      filterProperty: "CreatedDateTime",
      filterValue: {
        startDate: "",
        endDate: "",
      },
    },

    {
      useThisFilter: true,
      filterTitle: "Supplier",
      filterType: "Select",
      filterOptions: [],
      filterProperty: "Supplier_Id",
      filterValue: {
        Id: "",
      },
    },
    {
      useThisFilter: false,
      filterTitle: "Staff",
      filterType: "Select",
      filterOptions: [],
      filterProperty: "Staff_Id",
      filterValue: {
        Id: "",
      },
    },
    {
      useThisFilter: false,
      filterTitle: "Invoice Status",
      filterType: "Select",
      filterOptions: [],
      filterProperty: "InvoiceStatus_Id",
      filterValue: {
        Id: "",
      },
    },

    {
      useThisFilter: true,
      filterTitle: "EXCL VAT",
      filterType: "NumberRange",
      filterOptions: [],
      filterProperty: "AmountLocalSubTotal",
      filterValue: {
        min: "",
        max: "",
      },
    },
    {
      useThisFilter: true,
      filterTitle: "INC VAT",
      filterType: "NumberRange",
      filterOptions: [],
      filterProperty: "AmountLocalTotal",
      filterValue: {
        min: "",
        max: "",
      },
    },
  ];
  const [allowedFilters, setAllowedFilters] = useState(allowedFiltersInit);
  const [showFilter, setShowFilter] = useState(false);
  const toggleShowFilter = () => {
    setShowFilter(!showFilter);
  };
  const [modalAddNewStaffHolidayCalendar, setModalAddNewStaffHolidayCalendar] =
    useState(false);
  const [modalAddNewStaffHolidayPeriod, setModalAddNewStaffHolidayPeriod] =
    useState(false);
  const [
    modalAddNewStaffHolidayNonWorkingDay,
    setModalAddNewStaffHolidayNonWorkingDay,
  ] = useState(false);
  const [
    modalAddNewStaffLeaveRestrictionPeriod,
    setModalAddNewStaffLeaveRestrictionPeriod,
  ] = useState(false);

  const toggleModalAddNewStaffHolidayCalendar = () => {
    setModalAddNewStaffHolidayCalendar(!modalAddNewStaffHolidayCalendar);
  };
  const toggleModalAddNewStaffHolidayPeriod = () => {
    setModalAddNewStaffHolidayPeriod(!modalAddNewStaffHolidayPeriod);
  };
  const toggleModalAddNewStaffHolidayNonWorkingDay = () => {
    setModalAddNewStaffHolidayNonWorkingDay(
      !modalAddNewStaffHolidayNonWorkingDay
    );
  };
  const toggleModalAddNewStaffLeaveRestrictionPeriod = () => {
    setModalAddNewStaffLeaveRestrictionPeriod(
      !modalAddNewStaffLeaveRestrictionPeriod
    );
  };

  // Task 24479. The other four tabs fetch the row they are editing through a
  // /data/{id} dispatch; leave types already come back complete on the list
  // call, so the row is handed straight to the popup rather than re-fetching
  // what is already on screen.
  const [modalAddNewStaffLeaveType, setModalAddNewStaffLeaveType] =
    useState(false);
  const [leaveTypeUpdateData, setLeaveTypeUpdateData] = useState(null);
  const toggleModalAddNewStaffLeaveType = () => {
    setModalAddNewStaffLeaveType(!modalAddNewStaffLeaveType);
  };

  const [isEdit, setIsEdit] = useState(false);
  const {
    staffHolidayCalendarDataAPI,
    staffHolidayCalendarPeriodDataAPI,
    calendarNonWorkingDayDataAPI,
    staffLeaveRestrictionPeriodDataAPI,
  } = useSelector((state) => ({
    staffHolidayCalendarDataAPI:
      state.StaffLeave.staffHolidayCalendarData?.staffholidaycalendar_data,
    staffHolidayCalendarPeriodDataAPI:
      state.StaffLeave.staffHolidayCalendarPeriodData
        ?.staffholidaycalendarperiod_data,
    calendarNonWorkingDayDataAPI:
      state.StaffLeave.calendarNonWorkingDayData?.calendarnonworkingday_data,
    staffLeaveRestrictionPeriodDataAPI:
      state.StaffLeave.staffLeaveRestrictionPeriodData
        ?.staffleaverestrictionperiod_data,
  }));

  return (
    <>
      {modalAddNewStaffLeaveType && (
        <CreateEditStaffLeaveTypeConfig
          modal={modalAddNewStaffLeaveType}
          setModal={setModalAddNewStaffLeaveType}
          toggle={toggleModalAddNewStaffLeaveType}
          isEdit={isEdit}
          updateData={leaveTypeUpdateData}
        />
      )}

      {modalAddNewStaffLeaveRestrictionPeriod && (
        <CreateEditStaffLeaveRestrictionPeriodConfig
          modal={modalAddNewStaffLeaveRestrictionPeriod}
          setModal={setModalAddNewStaffLeaveRestrictionPeriod}
          toggle={toggleModalAddNewStaffLeaveRestrictionPeriod}
          isEdit={isEdit}
          updateData={staffLeaveRestrictionPeriodDataAPI}
        />
      )}

      {modalAddNewStaffHolidayNonWorkingDay && (
        <CreateEditStaffHolidayNonWorkingDayConfig
          modal={modalAddNewStaffHolidayNonWorkingDay}
          setModal={setModalAddNewStaffHolidayNonWorkingDay}
          toggle={toggleModalAddNewStaffHolidayNonWorkingDay}
          isEdit={isEdit}
          updateData={calendarNonWorkingDayDataAPI}
        />
      )}

      {modalAddNewStaffHolidayCalendar && (
        <CreateEditStaffHolidayCalendarConfig
          modal={modalAddNewStaffHolidayCalendar}
          setModal={setModalAddNewStaffHolidayCalendar}
          toggle={toggleModalAddNewStaffHolidayCalendar}
          isEdit={isEdit}
          updateData={staffHolidayCalendarDataAPI}
        />
      )}

      {modalAddNewStaffHolidayPeriod && (
        <CreateEditStaffHolidayPeriodConfig
          modal={modalAddNewStaffHolidayPeriod}
          setModal={setModalAddNewStaffHolidayPeriod}
          toggle={toggleModalAddNewStaffHolidayPeriod}
          isEdit={isEdit}
          updateData={staffHolidayCalendarPeriodDataAPI}
        />
      )}
      <LocalDataSearch
        Page={"SettingsPage_StaffLeave_StaffHolidayCalendar"}
        ReceivedDataAPI={dataAPI} // Page Specific
        setSearchInActionShowLoading={setLoading} //Mandatory* can be on and off for search loading if data heavy page I recommend to use it
        activeSearchTab={activeTab}
        // recurringJobListDataAPI={recurringJobListData} // Job Page Spesific
        allowedSearchFilters={allowedSearchFilters}
        searchQuery={searchQuery}
        setSearchFilteredResults={setSearchResult}
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        toggleShowFilter={toggleShowFilter}
        allowedFiltersInit={allowedFiltersInit}
        allowedFilters={allowedFilters}
        setAllowedFilters={setAllowedFilters}
      />
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteStatus}
          onCloseClick={() => {
            setDeleteModal(false);
          }}
        />
      )}

      <SettingsPanel
        title="Staff Leave Settings"
        description="Leave types, holiday calendars, periods, non-working days and restrictions"
        tabs={Tabs.map((item) => ({ value: item.id, label: item.name }))}
        value={activeTab}
        onChange={setActiveTab}
      >
        <Row>
          <Col lg={12}>
            <Row className="g-4 align-items-center">
              <Col sm={3}>
                <div className="search-box">
                  <Input
                    // create search with jobs List Data
                    type="search"
                    className="form-control search"
                    placeholder="Search for..."
                    onChange={(e) => setSearchQuery(e.target.value)}
                    value={searchQuery}
                  />
                  <i className="ri-search-line search-icon"></i>
                </div>
              </Col>
              <div className="col-sm-auto ms-auto">
                <div className="hstack gap-2">
                  <button
                    type="button"
                    className="btn btn-info btn-info-filters"
                    onClick={toggleShowFilter}
                  >
                    <i className="ri-filter-3-line align-bottom me-1"></i>{" "}
                    Filters
                  </button>
                  <button
                    type="button"
                    className="btn btn-soft-primary"
                    disabled={staffHolidayCalendarGeneratePeriodsLoading}
                    onClick={() => dispatch(staffHolidayCalendarGeneratePeriods())}
                    title="Open the next renewal period for calendars flagged to auto-open, matching the scheduled job."
                  >
                    <i className="ri-calendar-2-line align-bottom me-1"></i>
                    {staffHolidayCalendarGeneratePeriodsLoading
                      ? "Generating..."
                      : "Generate Periods"}
                  </button>
                  <div
                    type="button"
                    className="btn btn-success add-btn btn-info-add-jobs"
                    id="create-btn"
                    onClick={() => {
                      if (activeTab === "1") {
                        toggleModalAddNewStaffHolidayCalendar();
                      }
                      if (activeTab === "2") {
                        toggleModalAddNewStaffHolidayPeriod();
                      }
                      if (activeTab === "3") {
                        toggleModalAddNewStaffHolidayNonWorkingDay();
                      }
                      if (activeTab === "4") {
                        toggleModalAddNewStaffLeaveRestrictionPeriod();
                      }
                      if (activeTab === "5") {
                        setLeaveTypeUpdateData(null);
                        toggleModalAddNewStaffLeaveType();
                      }
                      setIsEdit(false);
                    }}
                  >
                    <i className="ri-add-line align-bottom me-1"></i>
                    New Setup
                  </div>
                </div>
              </div>
            </Row>

            {activeTab === "1" && (
              <Row className={""}>
                <Col lg={12}>
                  <div className={"px-2"}>
                    {loading ? (
                      <LoadingSpinner />
                    ) : (
                      <>
                        {!isEmpty(searchResult) ? (
                          <TableContainer
                            columns={column_StaffHolidayCalendarList}
                            data={searchResult || []}
                            isGlobalFilter={false}
                            isAddUserList={false}
                            customPageSize={10}
                            className="custom-header-css"
                            divClass="table-responsive table-card mb-0"
                            tableClass="align-middle table-wrap"
                            theadClass="text-muted"
                            // handleLeadClick={handleLeadClicks}
                            isLeadsFilter={false}
                          />
                        ) : (
                          <>
                            <div>
                              <NoDataContent
                                titleText={` No Results for: ${searchQuery}`}
                                paragraphText={`Try Adjusting your query: ${searchQuery}`}
                                useButton={false}
                              />
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            )}
            {activeTab === "2" && (
              <Row className={""}>
                <Col lg={12}>
                  <div className={"px-2"}>
                    {loading ? (
                      <LoadingSpinner />
                    ) : (
                      <>
                        {!isEmpty(searchResult) ? (
                          <TableContainer
                            columns={column_StaffHolidayCalendarPeriodList}
                            data={searchResult || []}
                            isGlobalFilter={false}
                            isAddUserList={false}
                            customPageSize={10}
                            className="custom-header-css"
                            divClass="table-responsive table-card mb-0"
                            tableClass="align-middle table-wrap"
                            theadClass="text-muted"
                            // handleLeadClick={handleLeadClicks}
                            isLeadsFilter={false}
                          />
                        ) : (
                          <>
                            <div>
                              <NoDataContent
                                titleText={` No Results for: ${searchQuery}`}
                                paragraphText={`Try Adjusting your query: ${searchQuery}`}
                                useButton={false}
                              />
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            )}
            {activeTab === "3" && (
              <Row className={""}>
                <Col lg={12}>
                  <div className={"px-2"}>
                    {loading ? (
                      <LoadingSpinner />
                    ) : (
                      <>
                        {!isEmpty(searchResult) ? (
                          <TableContainer
                            columns={
                              column_StaffHolidayCalendarNonWorkingDayList
                            }
                            data={searchResult || []}
                            isGlobalFilter={false}
                            isAddUserList={false}
                            customPageSize={10}
                            className="custom-header-css"
                            divClass="table-responsive table-card mb-0"
                            tableClass="align-middle table-wrap"
                            theadClass="text-muted"
                            // handleLeadClick={handleLeadClicks}
                            isLeadsFilter={false}
                          />
                        ) : (
                          <>
                            <div>
                              <NoDataContent
                                titleText={` No Results for: ${searchQuery}`}
                                paragraphText={`Try Adjusting your query: ${searchQuery}`}
                                useButton={false}
                              />
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            )}
            {activeTab === "4" && (
              <Row className={""}>
                <Col lg={12}>
                  <div className={"px-2"}>
                    {loading ? (
                      <LoadingSpinner />
                    ) : (
                      <>
                        {!isEmpty(searchResult) ? (
                          <TableContainer
                            columns={column_StaffLeaveRestrictionPeriodList}
                            data={searchResult || []}
                            isGlobalFilter={false}
                            isAddUserList={false}
                            customPageSize={10}
                            className="custom-header-css"
                            divClass="table-responsive table-card mb-0"
                            tableClass="align-middle table-wrap"
                            theadClass="text-muted"
                            // handleLeadClick={handleLeadClicks}
                            isLeadsFilter={false}
                          />
                        ) : (
                          <>
                            <div>
                              <NoDataContent
                                titleText={` No Results for: ${searchQuery}`}
                                paragraphText={`Try Adjusting your query: ${searchQuery}`}
                                useButton={false}
                              />
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            )}

            {activeTab === "5" && (
              <Row className={""}>
                <Col lg={12}>
                  <div className={"px-2"}>
                    {staffLeaveTypeListLoading ? (
                      <LoadingSpinner />
                    ) : (
                      <>
                        {!isEmpty(searchResult) ? (
                          <TableContainer
                            columns={column_StaffLeaveTypeList}
                            data={searchResult || []}
                            isGlobalFilter={false}
                            isAddUserList={false}
                            customPageSize={10}
                            className="custom-header-css"
                            divClass="table-responsive table-card mb-0"
                            tableClass="align-middle table-wrap"
                            theadClass="text-muted"
                            isLeadsFilter={false}
                          />
                        ) : (
                          <div>
                            {/* Two different empty states: nothing set up at
                                all is a different problem from a search that
                                found nothing, and only one of them is worth a
                                warning. */}
                            {isEmpty(dataAPI) ? (
                              <NoDataContent
                                titleText={"No leave types yet"}
                                paragraphText={
                                  "Nobody can book leave until at least one exists. Use New Setup to add one."
                                }
                                useButton={false}
                              />
                            ) : (
                              <NoDataContent
                                titleText={` No Results for: ${searchQuery}`}
                                paragraphText={`Try Adjusting your query: ${searchQuery}`}
                                useButton={false}
                              />
                            )}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </SettingsPanel>
    </>
  );
}
